import React, { Component } from 'react'
import { Table, Tooltip, Modal, Checkbox, message, Collapse, Form, Select, Input, DatePicker, Button, Card, Badge } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import Currency from 'react-currency-formatter';
import { all, get, update } from '../../services/restApi'
import InvoiceMessage from './invoiceMessage'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const Panel = Collapse.Panel
const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const ButtonGroup = Button.Group;

class Invoice extends Component {

	constructor (props) {
        super(props);

        this.state = {
        	query: {},
            hotels: [],
            showModalInvoiceDetails: false
        }

        message.config({top: 110, duration: 4});

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        let query = {};

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }


	/**
	* Carga otro bloque de registros
	*/
    loadMore () {
    	if (this.props.invoice.skip < this.props.invoice.total_items) {

            if (this.props.app.user.type === 'gerente') {
                this.setState({query: {
                    ...this.state.query, 
                    client: {
                        $inQuery: {
                            where: {
                                hotel: {$in: this.props.app.user.hotels}
                            },
                            className: 'Client'
                        }
                    }
                }});
            }

            if (this.state.currentHotel) {
                this.setState({query: {
                    ...this.state.query, 
                    client: {
                        $inQuery: {
                            where: {
                                hotel: {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
                            },
                            className: 'Client'
                        }
                    }
                }});
            }

            if (this.props.app.user.type === 'recepcionista') {
                this.setState({query: {
                    createdBy: {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId},
                }});
            }

    		this.props.dispatch({type: 'invoice/query', payload: {
    			where: this.state.query,
				skip: this.props.invoice.skip,
				limit: this.props.invoice.limit,
				count: 1,
				order: '-createdAt'
	    	}});
    	}
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
    	let dispatch = this.props.dispatch

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar la factura?',
	      	onOk () {
	        	dispatch({type: 'invoice/removeItem', payload: item});
	      	}
	    })
    }


    /**
    * Cada que se selecciona un registro (Finalizar factura)
    */
    finish_invoice (invoice) {
    	let dispatch = this.props.dispatch

    	this.props.dispatch({type: 'app/showLoadingTable'})

    	update('Invoice', invoice.objectId, {
            finished: !invoice.finished,
            folio: this.props.form.getFieldValue('folio')
        }).then(resp => {
    		this.props.dispatch({type: 'app/hideLoadingTable'})
    		dispatch({ type: 'invoice/updateSuccess', payload: {
                ...invoice, 
                finished: !invoice.finished,
                folio: this.props.form.getFieldValue('folio')
            }});

            this.hideModalInvoiceDetails();

    	}).catch(e => {
    		this.props.dispatch({type: 'app/hideLoadingTable'})

            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error. Intente más tarde')    
    	});
  	}


  	/**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Muestra el modal de los detalles del cliente
    */
    showInvoiceDetails (id) {
        this.props.dispatch({type: 'app/showLoading'})

        get('Invoice', id, {include: 'client,client.hotel,createdBy'}).then((resp) => {

            this.setState({ currentInvoice: resp });
            this.props.dispatch({type: 'app/hideLoading'})
            this.setState({ showModalInvoiceDetails: true });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoading'})
            message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
        });
    }

    hideModalInvoiceDetails () { this.setState({ showModalInvoiceDetails: false, showModalFolio: false }); }
    showModalFolio (invoice) { this.setState({ showModalFolio: true, currentInvoice: invoice }); }


    /**
    * Muestra el modal de los mensajes de la factura
    */
    showMessages (id) { 
        this.setState({ messageProps: {invoiceId: id} });
        this.setState({ showModalMessages: true });
    }

    hideModalMessages () { this.setState({ showModalMessages: false }); }


  	/**
    * Búsqueda
    */
    search (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            let query = this.state.query;
        	query = _.omit(query, ['client', 'reservation', 'name', 'finished', 'createdAt'])

        	// Query
        	if (values.hotel && values.hotel.key) {
        		query.client = {
                    $inQuery: {
                        where: {
                            hotel: {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key}
                        },
                        className: 'Client'
                    }
        		}
        	}

            if (this.props.app.user.type === 'recepcionista') {
                query.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId}
            }

        	if (values.reservation) 
        		query.reservation = values.reservation

            if (values.name) {
                query.client = {
                    $inQuery: {
                        where: {
                            name: {$regex: '(?i)' + values.name}
                        },
                        className: 'Client'
                    }
                }
            }

        	if (values.status && values.status === 'pendiente')
        		query.finished = false

        	if (values.status && values.status === 'finalizado')
        		query.finished = true

        	if (values.date && values.date[0] && values.date[1]) {
        		query.createdAt ={
    				$gte: {__type: 'Date', iso: new Date(values.date[0])},
    				$lte: {__type: 'Date', iso: new Date(values.date[1])}
        		}
        	}


        	this.setState({query: query});

            this.props.dispatch({type: 'invoice/filter', payload: {
            	where: query,
				skip: 0,
				limit: this.props.invoice.limit,
				count: 1,
				order: '-createdAt'
	    	}});
        })
    }


  	/**
    * Render del componente
    */
    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>Facturas</h1>
	            </section>

	            <section className="content">

	            	<Collapse defaultActiveKey={['0']} className="marginBottom20">
					    <Panel header="Búsqueda" key="1">
					      	<Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                    {!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-3">
                                        <FormItem label="# de Reservación" hasFeedback>
                                            {this.props.form.getFieldDecorator('reservation')(<Input size='large' placeholder="Omita escribir el ID-" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Nombre" hasFeedback>
                                            {this.props.form.getFieldDecorator('name')(<Input size='large' placeholder="Escribir el nombre" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Fecha de solicitud" hasFeedback>
                                            {this.props.form.getFieldDecorator('date')(
                                                <RangePicker 
                                                    showTime={{ format: 'HH:mm' }}
                                                    format="DD-MM-YYYY HH:mm"
                                                    onOk={resp => {
                                                        console.log(resp);
                                                    }} />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Status" hasFeedback>
                                            {this.props.form.getFieldDecorator('status')(
                                                <Select size="large" placeholder="Elija una opción">
                                                	<Option key="todos" value="">Todos</Option>
                                                    <Option key="pendiente" value="pendiente">Pendiente</Option>
                                                    <Option key="finalizado" value="finalizado">Finalizado</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>
                                </div>

	                            <div className="row text-center paddingBottom30">
	                                <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
	                                    Buscar...
	                                </Button>
	                            </div>
		                    </Form>
					    </Panel>
					</Collapse>

	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.invoice.invoices} 
		                                    	rowKey="objectId" 
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}
		                                    	rowClassName={(record, index) => {
		                                    		if (record.finished) {
		                                    			return 'finished'
		                                    		}
		                                    	}}>

                                                <Column title="Realizado" key="finished" render={(item) => (
		                                        	<Checkbox checked={item.finished} onChange={() => { this.showModalFolio(item) } } disabled={this.props.app.user.type !== 'administrador' ? true : false} />
		                                        )}/>
		                                    	<Column title="Fecha" key="createdAt" render={(item) => (
		                                        	<span>{moment(item.createdAt).format('DD/MM/YYYY')}</span>
		                                        )} />
                                                <Column title="Folio" key="folio" render={(item) => (
                                                    <span>{item.folio ? item.folio : '-'}</span>
                                                )} />
                                                <Column title="Nombre" key="client" render={(item) => (
                                                    <span>
                                                        <span className="color-primary">{item.client ? item.client.name : '-'}{item.hasMessages}</span><br />
                                                        {item.client && item.client.emails.map(d => <small key={d}>{d}<br /></small>)}
                                                    </span>
                                                )} />
		                                        <Column title="# de reservación" key="reservation" render={(item) => (
		                                        	<span>
                                                        ID-{item.reservation}<br />
                                                        <small>{item.client ? item.client.hotel.name : '-'}</small>
                                                    </span>
		                                        )}/>
		                                        <Column title="Check-in" key="checkin" render={(item) => (
		                                        	<span>{moment(item.checkin.iso).format('DD/MM/YYYY')}</span>
		                                        )}/>
		                                        <Column title="Check-out" key="checkout" render={(item) => (
		                                        	<span>{moment(item.checkout.iso).format('DD/MM/YYYY')}</span>
		                                        )}/>
		                                        <Column title="Monto a Facturar" key="amount" render={(item) => (
		                                        	<span>
                                                        <Currency quantity={item.amount} currency="USD" /><br />
                                                        <small>{item.payment_method ? item.payment_method : 'otro'}</small>
                                                    </span>
		                                        )}/>
                                                {this.props.app.user && this.props.app.user.type !== 'recepcionista'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
		                                        <Column title="Acciones" key="action" width={150}
		                                            render={(item) => (
		                                                <span className="actions">
                                                            <ButtonGroup>
    		                                                    <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link to={`/invoices/details/${item.objectId}`}><Icon name="edit" /></Link>
                                                                    </Button>
    		                                                    </Tooltip>

                                                                {this.props.app.user.type === 'administrador'
                                                                    ? <Tooltip placement="bottom" title="Ver detalles">
                                                                        <Button>
                                                                            <Link onClick={() => { this.showInvoiceDetails(item.objectId) }}><Icon name="search" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }

                                                                <Tooltip placement="bottom" title="Chat">
                                                                    <Button>
                                                                        <Link onClick={() => { this.showMessages(item.objectId) }}>
                                                                            {item.hasMessages
                                                                                ? <span><Badge dot><Icon name="comments" /></Badge></span> 
                                                                                : <span><Icon name="comments" /></span>
                                                                            }
                                                                        </Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {this.props.app.user.type === 'administrador'
        		                                                    ? <Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
        		                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
		                                                </span>
		                                            )}
		                                        />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>

                <Modal
                    visible={this.state.showModalInvoiceDetails}
                    title="Detalles de la Factura"
                    onCancel={this.hideModalInvoiceDetails.bind(this)}
                    footer={[
                        <Button key="back" onClick={this.hideModalInvoiceDetails.bind(this)}>Cerrar</Button>,
                        <Button key="details" type="primary" onClick={() => { this.setState({ showModalFolio: true }); }} disabled={this.state.currentInvoice ? this.state.currentInvoice.finished : false}>
                            <Icon name="check" /> Factura Finalizada
                        </Button>
                    ]}
                >
                    {this.state.currentInvoice
                        ? <div>
                            <Card title="Datos de la factura" className="marginBottom20">
                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Fecha: 
                                    </div>
                                    <div className="col-sm-7">
                                        {moment(this.state.currentInvoice.createdAt).format('ll')}
                                    </div>
                                </div>

                                {this.state.currentInvoice.folio
                                    ? <div className="row">
                                        <div className="col-sm-5 text-bold">
                                            Folio: 
                                        </div>
                                        <div className="col-sm-7">
                                            <code>{this.state.currentInvoice.folio}</code>
                                        </div>
                                    </div>
                                    : ''
                                }

                                {this.state.currentInvoice.client
                                    ? <div className="row">
                                        <div className="col-sm-5 text-bold">
                                            Hotel: 
                                        </div>
                                        <div className="col-sm-7">
                                            {this.state.currentInvoice.client.hotel ? this.state.currentInvoice.client.hotel.name : ''}
                                        </div>
                                    </div>
                                    : ''
                                }

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Creado por: 
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentInvoice.createdBy ? this.state.currentInvoice.createdBy.name : ''}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        # Reservación:
                                    </div>
                                    <div className="col-sm-7">
                                        ID-{this.state.currentInvoice.reservation}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Check-in:
                                    </div>
                                    <div className="col-sm-7">
                                        {moment(this.state.currentInvoice.checkin.iso).format('ll')}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Check-out:
                                    </div>
                                    <div className="col-sm-7">
                                        {moment(this.state.currentInvoice.checkout.iso).format('ll')}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Método de pago:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentInvoice.payment_method ? this.state.currentInvoice.payment_method : 'otro'}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Monto a facturar: 
                                    </div>
                                    <div className="col-sm-7">
                                        <Currency quantity={this.state.currentInvoice.amount} currency="USD" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Observaciones:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentInvoice.observations}
                                    </div>
                                </div>
                            </Card>

                            {this.state.currentInvoice.client
                                ? 
                                <span>
                                    <Card title="Datos del cliente" className="marginBottom20">
                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Nombre completo, denominación o razón social:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.name}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Tipo de persona:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.type}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                RFC:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.rfc}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Calle:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.street}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Número exterior:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.exterior_number}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Colonia:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.colony}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Número interior:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.interior_number}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Localidad:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.locality}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Referencia:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.reference}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Municipio:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.town}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                País:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.country}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Estado:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.state}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Código Postal:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.zip}
                                            </div>
                                        </div>
                                    </Card>

                                    <Card title="Datos de contacto">
                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Nombre del contacto:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.contact_name}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Teléfono 1:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.phone1}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Teléfono 2:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.phone2}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Celular:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.mobile_phone}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Fax:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.fax}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-5 text-bold">
                                                Emails:
                                            </div>
                                            <div className="col-sm-7">
                                                {this.state.currentInvoice.client.emails.map(d => <span key={d}>{d}<br /></span>)}
                                            </div>
                                        </div>
                                    </Card>
                                </span>
                                : ''
                            }
                        </div>
                        : ''
                    }
                </Modal>

                <Modal
                    visible={this.state.showModalMessages}
                    title="Mensajes"
                    onCancel={this.hideModalMessages.bind(this)}
                    footer={[
                        <Button key="back" onClick={this.hideModalMessages.bind(this)}>Cerrar</Button>
                    ]} 
                >
                    {this.state.showModalMessages
                        ? <InvoiceMessage {...this.state.messageProps} />
                        : ''
                    }
                </Modal>

                <Modal
                    visible={this.state.showModalFolio}
                    title="Asignación de Folio"
                    onCancel={() => { this.setState({ showModalFolio: false }); }}
                    footer={[
                        <Button key="back" onClick={() => { this.setState({ showModalFolio: false }); }}>Cerrar</Button>,
                        <Button key="details" type="primary" onClick={() => { this.finish_invoice(this.state.currentInvoice) }} disabled={this.state.currentInvoice ? this.state.currentInvoice.finished : false}>
                            <Icon name="check" /> Asignar Folio
                        </Button>
                    ]} 
                >
                    {this.state.showModalFolio
                        ? <div>
                            <FormItem label="Folio" hasFeedback>
                                {this.props.form.getFieldDecorator('folio')(<Input size='large' />)}
                            </FormItem>
                        </div>
                        : ''
                    }
                </Modal>
	        </div>
	    )
	}
}

export default connect(({invoice, app}) => ({invoice, app}))(Form.create()(Invoice))


// WEBPACK FOOTER //
// ./src/components/invoices/index.js